import { FormState } from "react-hook-form";
import { intl } from "LocaleWrapper";

import { Card } from "@cofano/cck";
import { Alert, Box, Tab, Tabs } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

import { FormattedDateWindow } from "utils/DateUtils";
import { Language } from "utils";

import { VoyageSchemaInput } from "view/voyages/utils/voyage.schema";

interface CallListProps {
	calls: Pick<VoyageSchemaInput["calls"][number], "id" | "pta" | "ptd" | "location">[];
	selectedIndex: number;
	onSelect: (index: number) => void;
	errors?: FormState<VoyageSchemaInput>["errors"];
}

const VoyageCallsTabsForm = ({ calls, selectedIndex, onSelect, errors }: CallListProps) => {
	return (
		<Box mb={1.5}>
			{calls.length > 0 ? (
				<Tabs
					value={selectedIndex}
					onChange={(_, value) => onSelect(value)}
					variant="scrollable">
					{calls.flatMap((call, index) => {
						const hasError = !!errors?.calls?.[index];
						return [ (
							<Tab
								key={call.id ?? `-${index}`}
								value={index}
								label={(
									<Card disablePadding>
										<Box
											sx={{
												borderTop: (theme) => hasError ? `2px solid ${theme.palette.error.main}` : undefined,
												color: (theme) => hasError ? theme.palette.error.main : undefined,
												display: "flex",
												flexDirection: "column",
												padding: "16px 32px",
											}}>
											<span>{call.location ? call.location.description : intl.formatMessage({ id: "UNKNOWN" })}</span>
											<small><FormattedDateWindow from={call.pta} to={call.ptd} withoutYear /></small>
										</Box>
									</Card>
								)}
								style={{
									padding: 0,
									marginRight: "16px",
								}} />
						), index !== (calls.length - 1) ? (
							<Tab
								key={`${call.id ?? `-${index}`}-divider`}
								value={"none"}
								label={<ArrowRightAltIcon />}
								style={{
									padding: 0,
									marginRight: "16px",
								}}
								disabled
							/>
						) : undefined ];
					})}
				</Tabs>
			) : (
				<Alert severity="warning">
					{Language("NO_CALLS_FOUND")}
				</Alert>
			)}
		</Box>
	);
};

export default VoyageCallsTabsForm;
